import loop1 from "../../loops/120_future_funk_beats_25.mp3";
import loop2 from "../../loops/120_stutter_breakbeats_16.mp3"
import loop3 from "../../loops/Bass Warwick heavy funk groove on E 120 BPM (1).mp3";
import loop4 from "../../loops/electric guitar coutry slide 120bpm - B.mp3";
import loop5 from "../../loops/FUD_120_StompySlosh.mp3";
import loop6 from "../../loops/GrooveB_120bpm_Tanggu.mp3";
import loop7 from "../../loops/MazePolitics_120_Perc.mp3";
import loop8 from "../../loops/PAS3GROOVE1.03B.mp3";
import loop9 from "../../loops/SilentStar_120_Em_OrganSynth.mp3";

const audio1 = new Audio(loop1);
audio1.loop = true;
const audio2 = new Audio(loop2);
audio2.loop = true;
const audio3 = new Audio(loop3);
audio3.loop = true;
const audio4 = new Audio(loop4);
audio4.loop = true;
const audio5 = new Audio(loop5);
audio5.loop = true;
const audio6 = new Audio(loop6);
audio6.loop = true;
const audio7 = new Audio(loop7);
audio7.loop = true;
const audio8 = new Audio(loop8);
audio8.loop = true;
const audio9 = new Audio(loop9);
audio9.loop = true;
const audioFiles = [audio1,audio2,audio3,audio4,audio5,audio6,audio7,audio8,audio9];

export default audioFiles;
